import { handleActions } from 'redux-actions';
import { NOT_REQUESTED, REQUESTED, FAILED, SUCCEEDED } from 'forms-utils-lib/RequestState';
import { REQUEST_NOTIFICATION_PREFERENCES, RECEIVE_NOTIFICATION_PREFERENCES, FAIL_GETTING_NOTIFICATION_PREFERENCES } from 'ui-forms-editor-automation-lib/actions/fetchNotificationPreferences';
export const INITIAL_STATE = {
  notificationPreferences: {},
  requestState: NOT_REQUESTED
};
export default handleActions({
  [REQUEST_NOTIFICATION_PREFERENCES]: state => Object.assign({}, state, {
    requestState: REQUESTED
  }),
  [RECEIVE_NOTIFICATION_PREFERENCES]: (_, {
    payload
  }) => ({
    notificationPreferences: payload,
    requestState: SUCCEEDED
  }),
  [FAIL_GETTING_NOTIFICATION_PREFERENCES]: state => Object.assign({}, state, {
    requestState: FAILED
  })
}, INITIAL_STATE);